import React, { Component, useCallback, useState } from 'react';
import clsx from 'clsx';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';
import moment from 'moment';
import queryString from 'query-string';
import FileSaver from 'file-saver';
import jstz from 'jstimezonedetect';
import InfiniteScroll from 'react-infinite-scroller';
import LogRow from './LogRow';
import LogsSettingsModal from './LogsSettingsModal';
import CustomReportsModal from './CustomReportsModal';
import { bigNumberToText, httpPost, localTimezoneUtc, updateUserToState } from '../utils';
import Common from '@silverfort-nodelibs/common/utils/common';
import {
    AUTH_LOGS_MAX_DOCS_TO_SEARCH_DEFAULT,
    AUTHENTICATOR_FILTER_ID,
    AUTHENTICATOR_TYPES,
    AZURE_SSO_AUTHENTICATION_VALUE,
    DEFAULT_MASK,
    FEATURE_FLAGS_NAMES,
    HTTP_OPTIONS,
    INFINITE_SCROLL_BATCH_SIZE,
    LOGS_DISPLAY_ACCOUNT_TYPES,
    RANGE_FILTER_TYPES
} from '@silverfort-nodelibs/common/utils/consts';
import ChatBotInsufficientPermissionsPopover from '../chatbot/ChatBotInsufficientPermissionsDialog';
import exportIcon from './Images/export.png';
import refreshIcon from '../common/Images/refresh.png';
import { Icon, Icons } from '@silverfort/sf-components';
import withFeature from '../FeatureFlag/WithFeature.js';
import LogsExportModal from './LogsExportModal';
import { orderBy } from 'lodash';
import { useChatbotAuthStatus } from '../chatbot/useChatbotAuthStatus.js';
import FiltersMenu from '../Controls/Filters/FiltersMenu.js';
import * as externalFilterTypes from '../Controls/Filters/externalFilterTypes';
import {
    destination,
    getInitialLogsFilter,
    protocol,
    range,
    requestID,
    source,
    users
} from '../Controls/Filters/FiltersObjects.js';
import { BOOLEAN, EXTERNAL } from '../Controls/Filters/filterTypes.js';
import { getFilterDescription } from '../Controls/Filters/Filters.js';
import { FeatureFlagContext } from '../FeatureFlag/FeatureFlagProvider';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import FiltersChatBot from './FiltersChatBot';
import { RISK_INDICATORS, RISK_INDICATORS_FOR_FILTERS_LIST } from '@silverfort-nodelibs/common/utils/insight.js';
import { LayoutContext } from '../../TowerLayout/TowerLayoutProvider';
import { getFiltersByPricingModules } from './utils';

const FILTERS_NOT_IN_URL = ['reason'];
const LOGS_COUNT_FOR_AI_DEFAULT_VALUE = -1;

class LogsLayout extends Component {
    static contextType = FeatureFlagContext;

    constructor(props, context) {
        super(props, context);
        const locale = navigator.languages ? navigator.languages : navigator.language;
        moment.locale(locale);

        this.state = {
            Logs: [],
            IsLoading: true,
            IsFetching: false,
            Users: [],
            LastIdentity: null,
            CompanyName: '',
            HasMoreLogs: false,
            FilterSearch: false,
            QueryType: 2,
            RulesNames: [],
            WallNames: {},
            LoadInitialData: true,
            UsersData: [],
            UsernamesData: [],
            filters: { ...getInitialLogsFilter(this.props.systemMode) },
            allowDesktopMfa: false,
            externalIntegrationEnabled: false,
            showLogsSettingsModal: false,
            showLogsExportModal: false,
            showCustomReportsModal: false,
            displayAccountType: LOGS_DISPLAY_ACCOUNT_TYPES.SHORT_UPN.value,
            authLogsAggsMaxDocsToSearch: AUTH_LOGS_MAX_DOCS_TO_SEARCH_DEFAULT,
            newCustomFilterName: '',
            customFilters: {},
            customReports: {},
            selectedCustomFilter: '',
            filtersChatBot: false,
            closeAllFiltersForFiltersChatBot: false,
            showInternalAuthLogs: true,
            GroupPolicies: []
        };
    }

    extractDestinationsIpOrNameFromSimplifiedFilters = (filters, key, value) => {
        for (const desIpOrName of value) {
            if (!filters[destination.id].externalSelections) {
                filters[destination.id].externalSelections = {
                    entities: [],
                    ipEntities: [],
                    unmanagedEntities: [{ name: desIpOrName, excluded: key.startsWith('exclude') }]
                };
            } else {
                filters[destination.id].externalSelections.unmanagedEntities.push({
                    name: desIpOrName,
                    excluded: key.startsWith('exclude')
                });
            }

            filters[destination.id].value.push({
                label: desIpOrName,
                value: desIpOrName,
                excluded: key.startsWith('exclude')
            });
        }
    };

    extractSourceIpOrNameFromSimplifiedFilters = (filters, key, value) => {
        for (const sourceIpOrName of value) {
            if (!filters[source.id].externalSelections) {
                filters[source.id].externalSelections = {
                    entities: [],
                    ipEntities: [],
                    unmanagedEntities: [{ name: sourceIpOrName, excluded: key.startsWith('exclude') }]
                };
            } else {
                filters[source.id].externalSelections.unmanagedEntities.push({
                    name: sourceIpOrName,
                    excluded: key.startsWith('exclude')
                });
            }

            filters[source.id].value.push({
                label: sourceIpOrName,
                value: sourceIpOrName,
                excluded: key.startsWith('exclude')
            });
        }
    };

    extractSourcesFromSimplifiedFilters = (filters, key, value) => {
        if (!filters[source.id].externalSelections) {
            filters[source.id].externalSelections = {
                entities: [],
                ipEntities: [],
                unmanagedEntities: []
            };
        }

        filters[source.id].externalSelections.entities.push(
            ...value.map((sourceGuid) => {
                return { guid: sourceGuid, excluded: key.startsWith('exclude') };
            })
        );
    };
    extractSourceIpsFromSimplifiedFilters = (filters, key, value) => {
        for (const sip of value) {
            if (!filters[source.id].externalSelections) {
                filters[source.id].externalSelections = {
                    ipEntities: [{ name: sip, excluded: key.startsWith('exclude') }],
                    entities: [],
                    unmanagedEntities: []
                };
            } else {
                filters[source.id].externalSelections.ipEntities.push({
                    name: sip,
                    excluded: key.startsWith('exclude')
                });
            }
            filters[source.id].value.push({
                label: sip,
                value: sip,
                excluded: key.startsWith('exclude')
            });
        }
    };
    extractDestinationsFromSimplifiedFilters = (filters, key, value) => {
        if (!filters[destination.id].externalSelections) {
            filters[destination.id].externalSelections = {
                entities: [],
                ipEntities: [],
                unmanagedEntities: [],
                applicationEntities: []
            };
        }

        filters[destination.id].externalSelections.entities.push(
            ...value.map((destGuid) => {
                return { guid: destGuid, excluded: key.startsWith('exclude') };
            })
        );
    };
    extractDestinationIpsFromSimplifiedFilters = (filters, key, value) => {
        if (!filters[destination.id].externalSelections) {
            filters[destination.id].externalSelections = {
                entities: [],
                ipEntities: [],
                unmanagedEntities: [],
                applicationEntities: []
            };
        }

        for (const dip of value) {
            const [address, mask] = dip.split('/');
            filters[destination.id].externalSelections.ipEntities.push({
                address,
                mask: mask || DEFAULT_MASK,
                name: dip,
                excluded: key.startsWith('exclude')
            });
            filters[destination.id].value.push({
                label: dip,
                value: dip,
                excluded: key.startsWith('exclude')
            });
        }
    };
    extractDestinationApplicationsFromSimplifiedFilters = (filters, key, value) => {
        if (!filters[destination.id].externalSelections) {
            filters[destination.id].externalSelections = {
                entities: [],
                ipEntities: [],
                applicationEntities: []
            };
        }

        filters[destination.id].externalSelections.applicationEntities.push(
            ...value.map((destAppGuid) => {
                return { guid: destAppGuid, excluded: key.startsWith('exclude') };
            })
        );
    };
    extractUsersFromSimplifiedFilters = (filters, key, value) => {
        if (!filters[users.id].externalSelections) {
            filters[users.id].externalSelections = {
                entities: [],
                unmanagedEntities: []
            };
        }

        filters[users.id].externalSelections.entities.push(
            ...value.map((userGuid) => {
                return { guid: userGuid, excluded: key.startsWith('exclude') };
            })
        );
    };
    extractUserNamesFromSimplifiedFilters = (filters, key, value) => {
        for (const un of value) {
            if (!filters[users.id].externalSelections) {
                filters[users.id].externalSelections = {
                    unmanagedEntities: [{ name: un, excluded: key.startsWith('exclude') }],
                    entities: []
                };
            } else {
                filters[users.id].externalSelections.unmanagedEntities.push({
                    name: un,
                    excluded: key.startsWith('exclude')
                });
            }
            filters[users.id].value.push({
                label: un,
                value: un,
                excluded: key.startsWith('exclude')
            });
        }
    };

    componentDidMount() {
        window.onpopstate = (e) => {
            window.location.reload();
        };

        updateUserToState(this, () => {
            const query = queryString.parse(this.props.location.search, { arrayFormat: 'comma', parseNumbers: true });

            // Fix number overflow
            if (query[requestID.id]) {
                query[requestID.id] = queryString.parse(this.props.location.search, {
                    arrayFormat: 'comma',
                    parseNumbers: false
                })[requestID.id];
            }

            const filters = { ...this.state.filters };
            const excludedFilters = new Set();

            if (query.excludedFilters) {
                if (!Array.isArray(query.excludedFilters)) {
                    excludedFilters.add(query.excludedFilters);
                } else {
                    query.excludedFilters.forEach((filter) => {
                        excludedFilters.add(filter);
                    });
                }

                delete query.excludedFilters;
            }

            // Rebuild filters data from query params
            if (query && Object.keys(query).length > 0) {
                for (const key of Object.keys(query)) {
                    let value = query[key];
                    if (value) {
                        if (!Array.isArray(value)) {
                            value = [value];
                        }
                        if (filters[key]) {
                            filters[key].value = value;
                            if (excludedFilters.has(key)) {
                                filters[key].isExcluded = true;
                            }
                        } else {
                            // Explanation:
                            // in order to load filters data from url, we rebuild Users, Destination and Source filter data.
                            // string based data is fully loaded here, while entity based data is partially loaded here,
                            // and fully loaded after receiving logs data from server.
                            if (key.endsWith('Sources')) {
                                this.extractSourcesFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('SourcesIps')) {
                                this.extractSourceIpsFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('SourceIpOrName')) {
                                this.extractSourceIpOrNameFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('Destinations')) {
                                this.extractDestinationsFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('DestinationsIps')) {
                                this.extractDestinationIpsFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('DestinationsIpOrName')) {
                                this.extractDestinationsIpOrNameFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('DestinationsApplications')) {
                                this.extractDestinationApplicationsFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('Users')) {
                                this.extractUsersFromSimplifiedFilters(filters, key, value);
                            } else if (key.endsWith('UserNames')) {
                                this.extractUserNamesFromSimplifiedFilters(filters, key, value);
                            }
                        }
                    }
                }
            }

            this.setState({
                HasMoreLogs: true,
                filters: filters,
                rawExportEnabled: this.props.location.pathname.toLowerCase().startsWith('/logs/rawexport')
            });
        });

        if (this.context.setLayoutContent) {
            const layoutData = (
                <>
                    {withFeature({
                        featureKey: FEATURE_FLAGS_NAMES.FiltersChatBot,
                        featureName: 'FiltersChatBot'
                    })(ChatbotButton)({
                        onClick: () => {
                            this.openFiltersChatBot();
                        }
                    })}
                </>
            );

            this.context.setLayoutContent(layoutData);
        }
    }

    componentWillUnmount() {
        this.props.appDrawerContext.closeAppDrawer();
        this.context.setLayoutContent('');
    }

    getExcludedFiltersWithValues(filtersWithValues) {
        const excludedFilters = [];
        for (const fkey in this.state.filters) {
            const isExcludedValue =
                filtersWithValues[fkey] !== undefined &&
                filtersWithValues[fkey] !== null &&
                this.state.filters[fkey].isExcluded;
            if (isExcludedValue) {
                excludedFilters.push(fkey);
            }
        }

        return excludedFilters;
    }

    saveToUrl(filters, excludedFilters) {
        let query = {};

        if (filters) {
            const filtersForUrl = {};
            for (const key in filters) {
                if (!FILTERS_NOT_IN_URL.includes(key)) {
                    filtersForUrl[key] = filters[key];
                }
            }
            query = filtersForUrl;
        }

        if (excludedFilters.length) {
            query.excludedFilters = excludedFilters;
        }

        if (query && Object.keys(query).length > 0) {
            const queryURL = queryString.stringify(query, { arrayFormat: 'comma' });
            window.history.replaceState(null, 'Silverfort', `${this.props.location.pathname}?${queryURL}`);
        } else {
            window.history.replaceState(null, 'Silverfort', this.props.location.pathname);
        }
    }

    exportLogsToFile(logsData, groupBy, isRaw) {
        if (isRaw) {
            const jsonResult = JSON.stringify(logsData.Logs);
            const blob = new Blob([jsonResult], { type: 'application/json' });
            FileSaver.saveAs(blob, `SilverfortRawLogs_${moment().local().format()}.json`);
        } else {
            const labels = {};
            for (const filterId in this.state.filters) {
                const isRelevantFilter =
                    !this.state.filters[filterId].isAdvanced || this.state.filters[filterId].value?.length;
                if (isRelevantFilter)
                    labels[filterId] = {
                        label: this.state.filters[filterId].label,
                        description: getFilterDescription(this.state.filters[filterId])
                    };
            }
            const csvresult = groupBy
                ? Common.getGroupByLogsForExport(
                      groupBy,
                      logsData.GroupByResult,
                      labels,
                      logsData.logsDisplayAccountType,
                      logsData.defaultDestinations
                  )
                : Common.getLogsForExport(
                      logsData.Logs,
                      logsData.RulesNames,
                      logsData.logsDisplayAccountType,
                      logsData.defaultDestinations,
                      this.state.GroupPolicies
                  );

            const blob = new Blob([csvresult], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(blob, 'silverfort.csv');
        }

        this.setState({ DuringExport: false, DuringRawExport: false, IsFetching: false });
    }

    processFilters() {
        const filtersWithValues = {};

        Object.keys(this.state.filters).forEach((sfKey) => {
            if (this.state.filters[sfKey].value !== null && this.state.filters[sfKey].value !== undefined) {
                if (Array.isArray(this.state.filters[sfKey].value)) {
                    if (
                        this.state.filters[sfKey].filterType === EXTERNAL &&
                        this.state.filters[sfKey].externalSelections
                    ) {
                        switch (this.state.filters[sfKey].id) {
                            case source.id: {
                                filtersWithValues['includeSources'] = [];
                                filtersWithValues['excludeSources'] = [];
                                filtersWithValues['includeSourcesIps'] = [];
                                filtersWithValues['excludeSourcesIps'] = [];
                                filtersWithValues['includeSourceIpOrName'] = [];
                                filtersWithValues['excludeSourceIpOrName'] = [];

                                for (const entity of this.state.filters[sfKey].externalSelections.entities) {
                                    if (entity.excluded) {
                                        filtersWithValues['excludeSources'].push(entity.guid);
                                    } else {
                                        filtersWithValues['includeSources'].push(entity.guid);
                                    }
                                }

                                for (const entity of this.state.filters[sfKey].externalSelections.ipEntities) {
                                    if (entity.excluded) {
                                        filtersWithValues['excludeSourcesIps'].push(entity.name.toLowerCase());
                                    } else {
                                        filtersWithValues['includeSourcesIps'].push(entity.name.toLowerCase());
                                    }
                                }

                                if (this.state.filters[sfKey].externalSelections.unmanagedEntities) {
                                    for (const entity of this.state.filters[sfKey].externalSelections
                                        .unmanagedEntities) {
                                        if (entity.excluded) {
                                            filtersWithValues['excludeSourceIpOrName'].push(entity.name.toLowerCase());
                                        } else {
                                            filtersWithValues['includeSourceIpOrName'].push(entity.name.toLowerCase());
                                        }
                                    }
                                }

                                break;
                            }
                            case destination.id: {
                                filtersWithValues['includeDestinations'] = [];
                                filtersWithValues['excludeDestinations'] = [];
                                filtersWithValues['includeDestinationsIps'] = [];
                                filtersWithValues['excludeDestinationsIps'] = [];
                                filtersWithValues['excludeDestinationsIpOrName'] = [];
                                filtersWithValues['includeDestinationsIpOrName'] = [];
                                filtersWithValues['includeDestinationsApplications'] = [];
                                filtersWithValues['excludeDestinationsApplications'] = [];

                                (this.state.filters[sfKey]?.externalSelections?.entities || []).forEach(
                                    ({ excluded, guid }) => {
                                        if (guid)
                                            filtersWithValues[
                                                excluded ? 'excludeDestinations' : 'includeDestinations'
                                            ].push(guid);
                                    }
                                );

                                (this.state.filters[sfKey]?.externalSelections?.ipEntities || []).forEach(
                                    ({ excluded, name }) => {
                                        if (name)
                                            filtersWithValues[
                                                excluded ? 'excludeDestinationsIps' : 'includeDestinationsIps'
                                            ].push(name.toLowerCase());
                                    }
                                );

                                (this.state.filters[sfKey]?.externalSelections?.applicationEntities || []).forEach(
                                    ({ excluded, guid }) => {
                                        if (guid)
                                            filtersWithValues[
                                                excluded
                                                    ? 'excludeDestinationsApplications'
                                                    : 'includeDestinationsApplications'
                                            ].push(guid);
                                    }
                                );

                                (this.state.filters[sfKey]?.externalSelections?.unmanagedEntities || []).forEach(
                                    ({ excluded, name }) => {
                                        if (name)
                                            filtersWithValues[
                                                excluded ? 'excludeDestinationsIpOrName' : 'includeDestinationsIpOrName'
                                            ].push(name.toLowerCase());
                                    }
                                );

                                break;
                            }
                            case users.id: {
                                filtersWithValues['includeUsers'] = [];
                                filtersWithValues['excludeUsers'] = [];
                                filtersWithValues['includeUserNames'] = [];
                                filtersWithValues['excludeUserNames'] = [];

                                for (const entity of this.state.filters[sfKey].externalSelections.entities) {
                                    if (entity.excluded) {
                                        filtersWithValues['excludeUsers'].push(entity.guid);
                                    } else {
                                        filtersWithValues['includeUsers'].push(entity.guid);
                                    }
                                }

                                for (const entity of this.state.filters[sfKey].externalSelections.unmanagedEntities) {
                                    if (entity.excluded) {
                                        filtersWithValues['excludeUserNames'].push(entity.name.toLowerCase());
                                    } else {
                                        filtersWithValues['includeUserNames'].push(entity.name.toLowerCase());
                                    }
                                }

                                break;
                            }
                            default: {
                                break;
                            }
                        }
                    } else if (this.state.filters[sfKey].value.length) {
                        filtersWithValues[sfKey] = this.state.filters[sfKey].value.map((value) =>
                            Number.isFinite(value) ? value : value.toString()
                        );
                        // TODO: Remove on v5.3
                        // This `if` statement ensures backward compatibility. For the bridge filter,
                        // we retrieve logs for both 'sso' and 'azure_sso' authentication types.
                        if (
                            sfKey === AUTHENTICATOR_FILTER_ID &&
                            this.state.filters[sfKey].value.includes(AUTHENTICATOR_TYPES.BRIDGE_SSO.value)
                        ) {
                            filtersWithValues[sfKey].push(AZURE_SSO_AUTHENTICATION_VALUE);
                        }
                    }
                } else {
                    const value = this.state.filters[sfKey].value;
                    filtersWithValues[sfKey] = Number.isFinite(value) ? value : value.toString();
                }
            }
        });

        return filtersWithValues;
    }

    loadLogs(forExport, groupBy, isRaw) {
        if (this.state.IsFetching) return;

        this.setState({ IsFetching: true }, () => {
            const filtersWithValues = this.processFilters();

            const startTime = new Date();
            const data = {
                localTimeZone: encodeURIComponent(jstz.determine().name()),
                LastIdentity: this.state.LastIdentity,
                LoadInitialData: this.state.LoadInitialData || forExport,
                ForExport: !!forExport,
                Filters: filtersWithValues,
                ExcludedFilters: this.getExcludedFiltersWithValues(filtersWithValues),
                GroupBy: groupBy
            };

            this.saveToUrl(data.Filters, data.ExcludedFilters);

            httpPost('/Logs/all', data)
                .then((res) => {
                    const logsData = res.data;

                    if (forExport) {
                        return this.exportLogsToFile(logsData, groupBy, isRaw);
                    }

                    if (this.state.LoadInitialData || forExport) {
                        const filtersWithData = { ...this.state.filters };

                        if (logsData.UsersData.length) {
                            filtersWithData[users.id].externalSelections = {
                                entities: [...logsData.UsersData],
                                unmanagedEntities: [
                                    ...this.state.filters[users.id].externalSelections.unmanagedEntities
                                ]
                            };

                            filtersWithData[users.id].value = logsData.UsersData.map((u) => {
                                return { label: u.name, value: u.guid, excluded: u.excluded };
                            });
                            filtersWithData[users.id].value.push(
                                ...filtersWithData[users.id].externalSelections.unmanagedEntities.map((u) => {
                                    return { label: u.name, value: u.name, excluded: u.excluded };
                                })
                            );
                        }

                        if (logsData.DestinationsData.length || logsData.ApplicationsData.length) {
                            const newExternalSelections = {
                                entities: [...(this.state.filters[destination.id]?.externalSelections?.entities || {})],
                                ipEntities: [...this.state.filters[destination.id].externalSelections.ipEntities],
                                applicationEntities: [
                                    ...(this.state.filters[destination.id]?.externalSelections?.applicationEntities ||
                                        {})
                                ],
                                unmanagedEntities: [
                                    ...this.state.filters[destination.id].externalSelections.unmanagedEntities
                                ]
                            };

                            if (logsData.DestinationsData.length) {
                                newExternalSelections.entities = [...logsData.DestinationsData];
                            }
                            if (logsData.ApplicationsData.length) {
                                newExternalSelections.applicationEntities = Object.values(
                                    logsData.ApplicationsData
                                ).map((app) => {
                                    app.applicationEntity = true;
                                    return app;
                                });
                            }
                            filtersWithData[destination.id].externalSelections = newExternalSelections;

                            filtersWithData[destination.id].value = logsData.DestinationsData.map((d) => {
                                return { label: d.name, value: d.guid, excluded: d.excluded };
                            });
                            filtersWithData[destination.id].value.push(
                                ...filtersWithData[destination.id].externalSelections.ipEntities.map((d) => {
                                    return { label: d.name, value: d.name, excluded: d.excluded };
                                })
                            );
                            filtersWithData[destination.id].value.push(
                                ...filtersWithData[destination.id].externalSelections.applicationEntities.map((d) => {
                                    return { label: d.name, value: d.name, excluded: d.excluded };
                                })
                            );

                            filtersWithData[destination.id].value.push(
                                ...filtersWithData[destination.id].externalSelections.unmanagedEntities.map((d) => {
                                    return { label: d.name, value: d.name, excluded: d.excluded };
                                })
                            );
                        }

                        if (logsData.SourcesData.length) {
                            filtersWithData[source.id].externalSelections = {
                                entities: [...logsData.SourcesData],
                                ipEntities: [...this.state.filters[source.id].externalSelections.ipEntities],
                                unmanagedEntities: [
                                    ...this.state.filters[source.id].externalSelections.unmanagedEntities
                                ]
                            };

                            filtersWithData[source.id].value = logsData.SourcesData.map((s) => {
                                return { label: s.name, value: s.name, excluded: s.excluded };
                            });
                            filtersWithData[source.id].value.push(
                                ...filtersWithData[source.id].externalSelections.ipEntities.map((s) => {
                                    return { label: s.name, value: s.name, excluded: s.excluded };
                                })
                            );
                            filtersWithData[source.id].value.push(
                                ...filtersWithData[source.id].externalSelections.unmanagedEntities.map((s) => {
                                    return { label: s.name, value: s.name, excluded: s.excluded };
                                })
                            );
                        }
                        const rangeFilter = logsData.filters?.find((filter) => filter.type === range.id);
                        if (rangeFilter) {
                            filtersWithData[range.id].value = rangeFilter.value;
                        }

                        this.setState({
                            LoadInitialData: false,
                            RulesNames: logsData.RulesNames,
                            GroupPolicies: logsData.GroupPolicies,
                            WallNames: logsData.WallNames,
                            allowDesktopMfa: logsData.allowDesktopMfa,
                            externalIntegrationEnabled: logsData.externalIntegrationEnabled,
                            customFilters: logsData.customFilters,
                            customReports: logsData.customReports,
                            countriesList: logsData.countriesList,
                            hiddenRiskIndicators: logsData.hiddenRiskIndicators || [],
                            ssoVendors: logsData.ssoVendors,
                            internalServiceAccounts: logsData.internalServiceAccounts || [],
                            defaultDestinations: logsData.defaultDestinations,
                            authLogsAggsMaxDocsToSearch: logsData.authLogsAggsMaxDocsToSearch,
                            filters: {
                                ...filtersWithData,
                                ...this.buildCountriesListFilter(logsData.countriesList),
                                ...this.buildIdPListFilter(logsData.ssoVendors),
                                ...(this.props.systemMode !== SYSTEM_MODES.SAAS &&
                                    this.buildNodeFilter(logsData.WallNames)),
                                ...this.buildRiskIndicatorFilter(logsData.hiddenRiskIndicators || []),
                                ...this.buildRuleNamesFilter(logsData.RulesNames || {}),
                                ...this.buildProtocolsFilter(logsData.allowDesktopMfa)
                            }
                        });
                    }

                    if (logsData.logsDisplayAccountType) {
                        this.setState({
                            displayAccountType: logsData.logsDisplayAccountType
                        });
                    }

                    if ('showInternalAuthLogs' in logsData) {
                        this.setState({
                            showInternalAuthLogs: logsData.showInternalAuthLogs
                        });
                    }

                    if (logsData.Logs && logsData.Logs.length > 0) {
                        this.setState((prevState) => ({
                            Logs: [...prevState.Logs, ...logsData.Logs],
                            LastIdentity: logsData.LastIdentity,
                            HasMoreLogs: logsData.Logs.length === INFINITE_SCROLL_BATCH_SIZE,
                            IsFetching: false,
                            DuringFilterRefresh: false,
                            LogsCount:
                                prevState.Logs && prevState.Logs.length > 0 ? prevState.LogsCount : logsData.LogsCount
                        }));
                    } else {
                        this.setState({
                            HasMoreLogs: false,
                            IsFetching: false,
                            LogsCount: 0,
                            DuringFilterRefresh: false
                        });
                    }

                    this.setState({ LogsCountForAi: this.state.LogsCount });

                    const endTime = new Date();
                    const diff = endTime.getTime() - startTime.getTime();

                    if (diff < 1000) {
                        setTimeout(() => {
                            //   this.setState({IsLoading: false});
                            $('.silverfort-loader').fadeOut(200);
                            this.state.IsLoading = false;
                        }, 1000 - diff);
                    } else {
                        $('.silverfort-loader').fadeOut(200);
                        this.state.IsLoading = false;
                    }
                })
                .catch((err) => {
                    console.error('Getting logs failed', err.toString());
                    this.setState({ IsLoading: false, IsFetching: false, HasMoreLogs: false });
                });
        });
    }

    extractFilterData(includeFilterName, excludeFilterName) {
        let filterData = [];
        if (this.state.filters[includeFilterName]) {
            filterData = filterData.concat(
                this.state.filters[includeFilterName].map((item) => {
                    return { name: item, excluded: false };
                })
            );
        }
        if (this.state.filetrs[excludeFilterName]) {
            filterData = filterData.concat(
                this.state.filters[excludeFilterName].map((item) => {
                    return { name: item, excluded: true };
                })
            );
        }
        return filterData;
    }

    exportLogs(groupBy) {
        this.setState({ DuringExport: true, showLogsExportModal: false });
        this.loadLogs(true, groupBy);
    }

    exportRawLogs() {
        this.setState({ DuringRawExport: true });
        this.loadLogs(true, null, true);
    }

    CheckboxStateChanged(event) {
        const target = event.target;
        const value = target.checked;
        const name = target.name;

        this.setState({ [name]: value }, () => {
            if (!value) {
                this.applyFilter();
            }
        });
    }

    buildCountriesListFilter = (countriesList) => {
        const countryFilterFields = { ...this.state.filters.country };
        const countriesOptions = Object.keys(countriesList).map((countryCode) => {
            return { value: countryCode.toUpperCase(), label: countriesList[countryCode] };
        });

        countryFilterFields.filterConfig = {
            options: countriesOptions,
            searchPlaceholder: 'Search country...',
            allowSearch: true,
            searchValue: '',
            allowExclude: true
        };

        return { country: countryFilterFields };
    };

    buildIdPListFilter = (idpList) => {
        const idpFilterFields = { ...this.state.filters.idp };
        const idpOptions = Object.values(idpList).map(({ id, name }) => {
            return { value: id, label: name };
        });

        idpFilterFields.filterConfig = {
            options: idpOptions
        };

        return { idp: idpFilterFields };
    };

    buildNodeFilter = (wallNames) => {
        const nodeFilterFields = { ...this.state.filters.node };
        let options = Object.keys(wallNames).map((wallKey) => {
            return { value: wallKey, label: wallNames[wallKey], extraData: wallKey };
        });

        if (options.length > 0) {
            options = orderBy(
                options,
                (option) => {
                    return option.label ? option.label.toLowerCase() : '';
                },
                ['asc']
            );

            nodeFilterFields.filterConfig.options = options;
        }

        return { node: nodeFilterFields };
    };

    buildRuleNamesFilter = (ruleNames) => {
        const RULES_STATES_PRIORITY = {
            '(disabled)': 1,
            '(deleted)': 2
        };

        let options = [];
        Object.keys(ruleNames).forEach((prefixedRuleId) => {
            const rule = ruleNames[prefixedRuleId];
            options.push({
                value: prefixedRuleId,
                label: rule.name,
                extraData: rule.is_deleted ? '(deleted)' : !rule.state ? '(disabled)' : ''
            });
        });

        if (options.length > 0) {
            options = orderBy(
                options,
                [
                    (option) => {
                        return RULES_STATES_PRIORITY[option.extraData] ? RULES_STATES_PRIORITY[option.extraData] : 0;
                    },
                    (option) => {
                        return option.label ? option.label.toLowerCase() : '';
                    }
                ],
                ['asc', 'asc']
            );
        }

        const ruleNamesFilterFields = { ...this.state.filters.ruleName };
        ruleNamesFilterFields.filterConfig.options = options;

        return { ruleName: ruleNamesFilterFields };
    };

    buildRiskIndicatorFilter = (hiddenRiskIndicators) => {
        let options = [];

        for (const riskIndicator of RISK_INDICATORS_FOR_FILTERS_LIST) {
            const riskRules = RISK_INDICATORS[riskIndicator].riskRules;
            if (!riskRules.every((riskRule) => hiddenRiskIndicators.includes(riskRule))) {
                options.push({
                    value: riskIndicator,
                    label: RISK_INDICATORS[riskIndicator].authTitle
                });
            }
        }

        if (options.length > 0) {
            options = orderBy(
                options,
                (option) => {
                    return option.label ? option.label.toLowerCase() : '';
                },
                ['asc']
            );
        }

        return {
            riskIndicator: {
                ...this.state.filters.riskIndicator,
                filterConfig: {
                    ...this.state.filters.riskIndicator.filterConfig,
                    options: options
                }
            }
        };
    };

    buildProtocolsFilter = (allowDesktopMfa) => {
        let options = [...protocol.filterConfig.options];

        if (this.props.systemMode !== SYSTEM_MODES.ON_PREM) {
            options = options.filter((op) => op.value !== 'RADIUS');
        }

        if (allowDesktopMfa) {
            options.push({ value: 'Desktop', label: 'Desktop' });
        }

        return {
            protocol: {
                ...this.state.filters.protocol,
                filterConfig: {
                    ...this.state.filters.protocol.filterConfig,
                    options: options
                }
            }
        };
    };

    onSaveLogsSettings = async (newAccountType, newShowInternalAuthLogs) => {
        await httpPost(
            '/Logs/saveLogsSettings',
            {
                displayAccountType: newAccountType,
                showInternalAuthLogs: newShowInternalAuthLogs
            },
            { [HTTP_OPTIONS.HANDLE_ERRORS]: true }
        );
        this.setState({
            Logs: [],
            LastIdentity: null,
            LoadInitialData: true,
            HasMoreLogs: true,
            displayAccountType: newAccountType,
            showInternalAuthLogs: newShowInternalAuthLogs,
            showLogsSettingsModal: false
        });
    };

    onSaveCustomReports = async (newCustomReport) => {
        this.setState({
            showCustomReportsModal: false
        });
        const response = await httpPost(
            '/Logs/saveCustomReport',
            { newCustomReport },
            { [HTTP_OPTIONS.HANDLE_ERRORS]: true }
        );
        if (response.data?.result) {
            this.setState({
                customReports: {
                    ...this.state.customReports,
                    [newCustomReport.reportName]: newCustomReport
                }
            });
        }
    };
    onDeleteCustomReports = async (reportName) => {
        this.setState({
            showCustomReportsModal: false
        });
        const response = await httpPost(
            '/Logs/deleteCustomReport',
            {
                reportName: reportName
            },
            { [HTTP_OPTIONS.HANDLE_ERRORS]: true }
        );
        if (response.data?.result) {
            const newCustomReports = { ...this.state.customReports };
            delete newCustomReports[reportName];
            this.setState({
                customReports: newCustomReports
            });
        }
    };

    saveCustomFilters = async (newFilterName) => {
        const filtersWithValues = this.processFilters();
        const excludedFilters = this.getExcludedFiltersWithValues(filtersWithValues);

        const creationDate = moment().format('MM/DD/YYYY');

        const response = await httpPost(
            '/Logs/saveCustomFilter',
            {
                newFilterName: newFilterName,
                selectedFilters: filtersWithValues,
                selectedExcludedFilters: excludedFilters,
                creationDate: creationDate
            },
            { [HTTP_OPTIONS.HANDLE_ERRORS]: true }
        );

        if (response.status !== 200) {
            return false;
        }

        const newCustomFilters = { ...this.state.customFilters };
        newCustomFilters[newFilterName] = {
            selectedFilters: filtersWithValues,
            selectedExcludedFilters: excludedFilters,
            creationDate: creationDate
        };
        this.setState({ customFilters: newCustomFilters, selectedCustomFilter: newFilterName });

        return true;
    };

    deleteCustomFilter = async (filterName) => {
        const response = await httpPost(
            '/Logs/deleteCustomFilter',
            {
                filterName: filterName
            },
            { [HTTP_OPTIONS.HANDLE_ERRORS]: true }
        );

        if (response.status !== 200) {
            return false;
        }
        if (filterName === this.state.selectedCustomFilter) {
            this.setState({ selectedCustomFilter: '' });
        }
        const newCustomFilters = { ...this.state.customFilters };
        delete newCustomFilters[filterName];
        this.setState({ customFilters: newCustomFilters });
        return true;
    };

    loadCustomFilter = (filterName) => {
        const selectedCustomFilter = this.state.customFilters[filterName];
        if (!selectedCustomFilter) {
            return false;
        }

        const newFilters = {};
        for (const key in this.state.filters) {
            newFilters[key] = this.state.filters[key];
            if (newFilters[key].filterType !== BOOLEAN) {
                newFilters[key].value = [];
            }
        }

        delete newFilters[users.id].externalSelections;
        delete newFilters[destination.id].externalSelections;
        delete newFilters[source.id].externalSelections;

        const excludedFilters = new Set([...selectedCustomFilter.selectedExcludedFilters]);
        const includedFilters = selectedCustomFilter.selectedFilters;

        for (const key of Object.keys(includedFilters)) {
            let value = includedFilters[key];
            if (value !== undefined) {
                if (!Array.isArray(value)) {
                    value = [value];
                }

                if (newFilters[key]) {
                    newFilters[key].value = value;
                    if (excludedFilters.has(key)) {
                        newFilters[key].isExcluded = true;
                    }
                } else {
                    // in order to load filters data from custom filters, we rebuild Users, Destination and Source filter data.
                    if (key.endsWith('Sources')) {
                        this.extractSourcesFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('SourcesIps')) {
                        this.extractSourceIpsFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('SourceIpOrName')) {
                        this.extractSourceIpOrNameFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('Destinations')) {
                        this.extractDestinationsFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('DestinationsIps')) {
                        this.extractDestinationIpsFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('DestinationsIpOrName')) {
                        this.extractDestinationsIpOrNameFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('DestinationsApplications')) {
                        this.extractDestinationApplicationsFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('Users')) {
                        this.extractUsersFromSimplifiedFilters(newFilters, key, value);
                    } else if (key.endsWith('UserNames')) {
                        this.extractUserNamesFromSimplifiedFilters(newFilters, key, value);
                    }
                }
            }
        }

        this.setState({
            filters: newFilters,
            selectedCustomFilter: filterName,
            Logs: [],
            LastIdentity: null,
            HasMoreLogs: true,
            LoadInitialData: true,
            DuringFilterRefresh: true
        });
        return true;
    };

    filterValueChangedHandler = (filterId, newValue, isExcluded = false) => {
        const newFilters = { ...this.state.filters };
        newFilters[filterId] = { ...newFilters[filterId] };

        const skipRefreshLogs = newValue === '';

        if (newFilters[filterId].filterType === EXTERNAL) {
            newFilters[filterId].value = [];
            newValue.objectEntities &&
                newFilters[filterId].value.push(
                    ...newValue.objectEntities.map((entity) => {
                        return {
                            label: entity.name || entity.display_name,
                            value: entity.guid,
                            excluded: entity.excluded
                        };
                    })
                );

            newValue.unmanagedEntities &&
                newFilters[filterId].value.push(
                    ...newValue.unmanagedEntities.map((entity) => {
                        return {
                            label: entity.name || entity.display_name,
                            value: entity.name,
                            excluded: entity.excluded
                        };
                    })
                );

            newValue.ipEntities &&
                newFilters[filterId].value.push(
                    ...newValue.ipEntities.map((entity) => {
                        return {
                            label: entity.name || entity.display_name,
                            value: entity.name,
                            excluded: entity.excluded
                        };
                    })
                );

            newValue.applicationEntities &&
                newFilters[filterId].value.push(
                    ...newValue.applicationEntities.map((entity) => {
                        return {
                            label: entity.name || entity.display_name,
                            value: entity.guid,
                            excluded: entity.excluded
                        };
                    })
                );

            newFilters[filterId].externalSelections = {
                entities: newValue.objectEntities || [],
                unmanagedEntities: newValue.unmanagedEntities || [],
                ipEntities: newValue.ipEntities || [],
                applicationEntities: newValue.applicationEntities || []
            };
        } else {
            newFilters[filterId].value = newValue !== null ? newValue : newFilters[filterId].defaultValue;
        }

        newFilters[filterId].isExcluded = isExcluded;

        this.setState({ filters: newFilters });

        if (!skipRefreshLogs)
            this.setState({
                Logs: [],
                LastIdentity: null,
                HasMoreLogs: true,
                LoadInitialData: !!newFilters,
                DuringFilterRefresh: true,
                selectedCustomFilter: ''
            });
    };

    filtersValueChangedAI = (filters, unsupportedFilters) => {
        this.setState({ LogsCountForAi: LOGS_COUNT_FOR_AI_DEFAULT_VALUE });
        const newFilters = { ...this.state.filters };
        const newFiltersKeys = new Set(Object.keys(filters));
        Object.keys(this.state.filters)
            .filter((key) => !unsupportedFilters.has(key))
            .forEach((filterKey, unsupportedFilters) => {
                if (!newFiltersKeys.has(filterKey)) {
                    newFilters[filterKey].value = newFilters[filterKey].defaultValue;
                    if (newFilters[filterKey].filterType === EXTERNAL) {
                        newFilters[filterKey].externalSelections = {
                            entities: [],
                            ipEntities: [],
                            unmanagedEntities: []
                        };
                        if (filterKey === destination.id) {
                            newFilters[filterKey].externalSelections = {
                                ...newFilters[filterKey].externalSelections,
                                applicationEntities: []
                            };
                        }
                    }
                } else {
                    if (filterKey === range.id) {
                        const startTimestamp = this.getEpochFromIsoString(filters[filterKey].startTime);
                        const endTimestamp = this.getEpochFromIsoString(filters[filterKey].endTime);

                        if (
                            newFilters[filterKey].value[1] !== startTimestamp ||
                            newFilters[filterKey].value[2] !== endTimestamp
                        ) {
                            newFilters[filterKey].value = [
                                RANGE_FILTER_TYPES.CUSTOM_RANGE.value,
                                startTimestamp,
                                endTimestamp
                            ];
                        }
                    } else {
                        if (filters[filterKey]?.value) {
                            let newValue = filters[filterKey].value;
                            newFilters[filterKey] = { ...newFilters[filterKey] };

                            if (newFilters[filterKey].filterType === EXTERNAL) {
                                newFilters[filterKey].value = [];
                                newValue = newValue.filter((x) => x.value);
                                const unmanagedEntities = newValue.map((entity) => {
                                    return {
                                        type: 1,
                                        unmanaged: true,
                                        name: entity.value,
                                        excluded: entity.excluded
                                    };
                                });

                                newFilters[filterKey].unmanagedEntities = unmanagedEntities;

                                newFilters[filterKey].value = newValue.map((entity) => {
                                    return {
                                        label: entity.value,
                                        value: entity.value,
                                        excluded: entity.excluded
                                    };
                                });

                                newFilters[filterKey].externalSelections = {
                                    entities: [],
                                    ipEntities: [],
                                    unmanagedEntities: unmanagedEntities || []
                                };

                                if (filterKey === destination.id) {
                                    newFilters[filterKey].externalSelections = {
                                        ...newFilters[filterKey].externalSelections,
                                        applicationEntities: []
                                    };
                                }
                            } else {
                                newFilters[filterKey].value = newValue;
                            }
                            newFilters[filterKey].isExcluded = filters[filterKey].excluded;
                        }
                    }
                }
            });

        this.setState({
            filters: newFilters,
            Logs: [],
            LastIdentity: null,
            HasMoreLogs: true,
            LoadInitialData: !!newFilters,
            DuringFilterRefresh: true,
            selectedCustomFilter: ''
        });
    };

    getEpochFromIsoString = (date) => {
        return Math.floor(new Date(date).getTime() / 1000);
    };

    entitiesSelectorConfig = {
        [externalFilterTypes.SERVERS_ONLY]: {
            showExcluded: true,
            allowIps: true,
            disableNetMasks: true,
            allowUnmanagedEntities: true
        },
        [externalFilterTypes.DEVICES_ONLY]: {
            showExcluded: true,
            allowIps: true,
            disableNetMasks: true,
            allowUnmanagedEntities: true
        },
        [externalFilterTypes.DEVICES]: {
            showExcluded: true,
            allowIps: true,
            disableNetMasks: true,
            allowUnmanagedEntities: true
        },
        [externalFilterTypes.USERS]: { showExcluded: true, allowUnmanagedEntities: true }
    };

    openFiltersChatBot() {
        this.setState({ filtersChatBot: true, closeAllFiltersForFiltersChatBot: true });
    }

    hideFiltersChatBot() {
        this.setState({ filtersChatBot: false, closeAllFiltersForFiltersChatBot: false });
    }

    clearFilters() {
        this.setState({ LogsCountForAi: LOGS_COUNT_FOR_AI_DEFAULT_VALUE });
        const keys = Object.keys(this.state.filters);
        const newFilters = { ...this.state.filters };
        keys.forEach((filterKey) => {
            if (newFilters[filterKey].value !== undefined) {
                newFilters[filterKey].value = newFilters[filterKey].defaultValue;
                if (newFilters[filterKey].filterType === EXTERNAL) {
                    newFilters[filterKey].externalSelections = {
                        entities: [],
                        ipEntities: [],
                        unmanagedEntities: []
                    };
                    if (filterKey === destination.id) {
                        newFilters[filterKey].externalSelections = {
                            ...newFilters[filterKey].externalSelections,
                            applicationEntities: []
                        };
                    }
                }
            }
        });

        newFilters[range.id].value = [RANGE_FILTER_TYPES.TODAY.value];

        this.setState({
            filters: newFilters,
            Logs: [],
            LastIdentity: null,
            HasMoreLogs: true,
            LoadInitialData: true,
            DuringFilterRefresh: true,
            selectedCustomFilter: ''
        });
    }

    render() {
        const filtersToDisplay = this.props.pricingModulesState
            ? getFiltersByPricingModules(this.state.filters, this.props.pricingModulesState)
            : this.state.filters;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />;
        }

        const logsRows = [];
        if (this.state.Logs && this.state.Logs.length > 0) {
            for (const log of this.state.Logs) {
                logsRows.push(
                    <LogRow
                        appDrawerContext={this.props.appDrawerContext}
                        logData={log}
                        key={'log_' + log.id}
                        rulesNames={this.state.RulesNames}
                        groupPolicies={this.state.GroupPolicies}
                        wallNames={this.state.WallNames}
                        user={this.state.user}
                        allowDesktopMfa={this.state.allowDesktopMfa}
                        displayAccountType={this.state.displayAccountType}
                        countriesList={this.state.countriesList}
                        hiddenRiskIndicators={this.state.hiddenRiskIndicators}
                        ssoVendors={this.state.ssoVendors}
                        defaultDestinations={this.state.defaultDestinations}
                        internalServiceAccounts={this.state.internalServiceAccounts}
                    />
                );
            }
        }
        return (
            <div id="logs">
                {this.state.IsLoading && (
                    <div className="silverfort-loader">
                        <div className="logo"></div>
                    </div>
                )}
                {this.state.showLogsSettingsModal && (
                    <LogsSettingsModal
                        accountType={this.state.displayAccountType}
                        showInternalAuthLogs={this.state.showInternalAuthLogs}
                        onCancel={() => {
                            this.setState({
                                showLogsSettingsModal: false
                            });
                        }}
                        onApprove={this.onSaveLogsSettings}
                    />
                )}
                {this.state.showLogsExportModal && (
                    <LogsExportModal
                        onCancel={() => {
                            this.setState({
                                showLogsExportModal: false
                            });
                        }}
                        onExport={(groupBy) => this.exportLogs(groupBy)}
                        authLogsAggsMaxDocsToSearch={this.state.authLogsAggsMaxDocsToSearch}
                        currentLogsCount={this.state.LogsCount}
                    />
                )}
                {this.state.showCustomReportsModal && (
                    <CustomReportsModal
                        customFilters={this.state.customFilters}
                        customReports={this.state.customReports}
                        authLogsAggsMaxDocsToSearch={this.state.authLogsAggsMaxDocsToSearch}
                        onCancel={() => {
                            this.setState({
                                showCustomReportsModal: false
                            });
                        }}
                        onApprove={this.onSaveCustomReports}
                        onDelete={this.onDeleteCustomReports}
                    />
                )}
                {withFeature({
                    featureKey: FEATURE_FLAGS_NAMES.FiltersChatBot,
                    featureName: 'FiltersChatBot'
                })(FiltersChatBot)({
                    open: this.state.filtersChatBot,
                    userId: 1,
                    onFiltersChange: this.filtersValueChangedAI,
                    filterState: this.state.filters,
                    clearFilters: () => {
                        this.clearFilters();
                    },
                    onHide: () => {
                        this.hideFiltersChatBot();
                    },
                    logsAmount: this.state.LogsCountForAi
                })}
                <div id="page-wrapper" className="page-wrapper">
                    <div className="logsHeader">
                        <div className="leftSide">
                            <span>Logs Table</span>
                            <span className="logsCount">{`(${bigNumberToText(this.state.LogsCount)})`}</span>
                            <div
                                className="refreshButton"
                                onClick={() => {
                                    this.setState({
                                        Logs: [],
                                        LastIdentity: null,
                                        LoadInitialData: true,
                                        HasMoreLogs: true
                                    });
                                }}>
                                <img src={refreshIcon} alt="" />
                            </div>
                        </div>
                        <div className="rightSide">
                            {this.state.rawExportEnabled &&
                                (this.state.DuringRawExport ? (
                                    <div className="logMenuBtns">Generating...</div>
                                ) : (
                                    <div className="logMenuBtns mr-4" onClick={() => this.exportRawLogs()}>
                                        <img src={exportIcon} alt="" />
                                        Export Raw
                                    </div>
                                ))}
                            {this.state.DuringExport ? (
                                <div className="logMenuBtns">Generating...</div>
                            ) : (
                                <div
                                    className="logMenuBtns"
                                    onClick={() =>
                                        this.setState({
                                            showLogsExportModal: true
                                        })
                                    }>
                                    <img src={exportIcon} alt="" />
                                    Export
                                </div>
                            )}
                            <div
                                className="logMenuBtns"
                                onClick={() => {
                                    this.setState({
                                        showLogsSettingsModal: true
                                    });
                                }}>
                                <div className="fa fa-cogs logsSettingsOptionIcon" />
                                Configure Logs
                            </div>
                            <div
                                className="logMenuBtns"
                                onClick={() => {
                                    this.setState({
                                        showCustomReportsModal: true
                                    });
                                }}>
                                <div className="fa fa-address-card-o logsSettingsOptionIcon" />
                                Custom reports
                            </div>
                        </div>
                    </div>
                    <div className="logsTableFilters">
                        <FiltersMenu
                            filters={Object.values(filtersToDisplay)}
                            onValueChange={(filterId, newValue, isExcluded) =>
                                this.filterValueChangedHandler(filterId, newValue, isExcluded)
                            }
                            customStyles={{ background: '#FFFFFF' }}
                            entitiesSelectorConfig={this.entitiesSelectorConfig}
                            closeAllFilters={this.state.closeAllFiltersForFiltersChatBot}
                            customFiltersConfig={{
                                saveCustomFilters: this.saveCustomFilters,
                                deleteCustomFilter: this.deleteCustomFilter,
                                loadCustomFilter: this.loadCustomFilter,
                                currentCustomFilters: this.state.customFilters,
                                selectedCustomFilter: this.state.selectedCustomFilter,
                                customReports: this.state.customReports,
                                rangeFilter: this.state.filters.range
                            }}
                        />
                    </div>
                    <div className="logsTable">
                        <div className="header superheader">
                            <div className="timestampColumn">
                                <span>Time {localTimezoneUtc()}</span>
                            </div>
                            <div className="userIdentifierColumn">
                                <span>Username</span>
                            </div>
                            <div className="hostnameColumn">
                                <span>Source</span>
                            </div>
                            <div className="serverColumn">
                                <span>Destination</span>
                            </div>
                            <div className="riskColumn">
                                <span>Risk</span>
                            </div>
                            <div className="protocolColumn">
                                <span>Auth Type</span>
                            </div>
                            <div className="ruleActionColumn">
                                <span>Silverfort Action</span>
                            </div>
                            <div className="actionColumn">
                                <span>IdP Result</span>
                            </div>
                        </div>
                        <div className="logsContainer light-scrollbar">
                            <InfiniteScroll
                                pageStart={0}
                                loadMore={() => this.loadLogs()}
                                hasMore={this.state.HasMoreLogs}
                                useWindow={false}
                                threshold={500}
                                loader={<div key={0} className="logsLoader"></div>}>
                                {logsRows}
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const ChatbotButton = ({ onClick }) => {
    const { isAuthorizedToUse, isPermittedToApproveUsage } = useChatbotAuthStatus();
    const disabled = !isAuthorizedToUse && !isPermittedToApproveUsage;
    const [showInsufficientPermissions, setShowInsufficientPermissions] = useState(false);

    const onClickWithAuthCheck = useCallback(() => {
        if (!disabled) {
            onClick();
        }
    }, [disabled, onClick]);

    const onMouseEnter = useCallback(() => {
        if (disabled && !showInsufficientPermissions) setShowInsufficientPermissions(true);
    }, [disabled, showInsufficientPermissions]);

    const onMouseLeave = useCallback(() => {
        if (disabled && showInsufficientPermissions) setShowInsufficientPermissions(false);
    }, [disabled, showInsufficientPermissions]);

    return (
        <div className="mr-3 h-8 group relative ">
            {disabled && showInsufficientPermissions && <ChatBotInsufficientPermissionsPopover />}
            <button
                className={clsx(
                    'flex gap-1 w-auto h-8 border border-sf-purple-500 rounded-3xl bg-white font-medium text-sm items-center justify-center pt-2 pr-4 pb-2 pl-3',
                    disabled
                        ? 'text-sf-gray-400 cursor-not-allowed'
                        : 'text-sf-purple-500 group-hover:bg-sf-purple-500 group-hover:text-white hover:duration-300'
                )}
                onClick={onClickWithAuthCheck}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}>
                {!disabled ? (
                    <>
                        <Icon icon={Icons.Magic} className="group-hover:hidden hover:duration-300" />
                        <Icon icon={Icons.Magic} className="hidden group-hover:block hover:duration-300 text-white" />
                    </>
                ) : (
                    <Icon icon={Icons.Magic} className="text-sf-gray-400" />
                )}
                <span>Filter with AI</span>
            </button>
        </div>
    );
};

LogsLayout.contextType = LayoutContext;

export default LogsLayout;
